module.exports = __webpack_public_path__ + "media/assets/images/radboud-logo-f5ddf954381008193421a822a3e42bf6.svg";